import { createContext as o } from "react";
const t = {
  isGroupedInput: !1
}, r = o(t);
export {
  r as FormGroupContext,
  t as defaultFormGroupContext
};
